// Surface backend-emitted warnings from a createJob response as user-facing
// alerts. The backend never blocks the upload on these — it just attaches a
// `duplicateDocumentWarnings` array if any of the uploaded PDFs already
// exist in the destination project (matched by S3 etag).

import { createAlert } from "../redux/reducers/Alerts";

interface DuplicatePrior {
  documentId: string;
  documentName: string;
  jobId: string | null;
  jobName: string | null;
  createdAt: string;
}
interface DuplicateWarning {
  newDocumentId: string;
  newDocumentName: string;
  s3ETag: string;
  priorDocuments: DuplicatePrior[];
}

interface JobCreateResponse {
  duplicateDocumentWarnings?: DuplicateWarning[];
}

export function surfaceJobCreateWarnings(
  dispatch: any,
  rsp: JobCreateResponse | undefined | null
): void {
  if (!rsp) return;
  const warnings = rsp.duplicateDocumentWarnings || [];
  if (warnings.length === 0) return;

  // Build a single multi-line warning rather than spamming N alerts. Lists
  // each duplicated upload and which prior job it lives in.
  const lines: string[] = [
    warnings.length === 1
      ? "1 of your uploads is already in this project:"
      : `${warnings.length} of your uploads are already in this project:`,
  ];
  for (const w of warnings) {
    const prior = w.priorDocuments[0];
    if (prior) {
      lines.push(
        `• "${w.newDocumentName}" matches "${prior.documentName}" in job "${prior.jobName || prior.jobId || ""}"`
      );
    } else {
      lines.push(`• "${w.newDocumentName}"`);
    }
  }
  lines.push("The new job was created anyway — review if these are intentional.");

  dispatch(
    createAlert({
      message: lines.join("\n"),
      timeout: 0,
      type: "info",
    })
  );
}
